import { z } from "zod";

export const Notification = z.object({
  id: z.string(),
  notification: z.string(),
  workspaceId: z.string(),
  userId: z.string(),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
})
export type Notification = z.infer<typeof Notification>;

export const NotificationType = z.enum(['Workspace', 'User'])
export type NotificationType = z.infer<typeof NotificationType>;

export const NotificationEntity = z.object({
  id: z.string(),
  notification: z.string(),
  workspaceId: z.string(),
  userId: z.string(),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
  new: z.boolean(),
  url: z.string().optional(),
  type: NotificationType,
  user: z.object({
    name: z.string(),
    image: z.string().nullish(),
  })
})
export type NotificationEntity = z.infer<typeof NotificationEntity>;

// Mappers
interface mapPrismaQueryToNotificationParams {
  isNew?: boolean,
  url?: string,
  type: NotificationType,
  user: {
    name: string,
    image?: string | null,
  }
}

export const mapPrismaQueryToNotification = (
  input: Notification,
  params: mapPrismaQueryToNotificationParams,
): NotificationEntity => {
  return {
    ...input,
    type: params.type,
    new: params.isNew ?? false,
    url: params.url,
    user: {
      name: params.user.name,
      image: params.user.image,
    }
  }
}